export class KissDialogConfig {
  data?: any;
  dialogClass?: string;
  dialogOverlayClass?: string;
  dialogContainerClass?: string;
  exitOnClickOutside?: boolean;
  exitOnEsc?: boolean;
}
